var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-page landing-static",class:{ 'rtl': _vm.locale === 'ar' }},[_c('AppHeader',{attrs:{"appName":"main","locale":_vm.locale}}),_c('main',[_c('AboutMenu'),_c('AboutQic'),_c('AboutWhyQic'),_c('AboutWhatOffer'),_c('AboutAwards'),_c('AboutLinks'),_c('AboutShortFacts')],1),_c('AppFooter',{attrs:{"locale":_vm.locale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }